import { Link } from 'react-router-dom';

import { Card, Flex, Icon, Typography } from '@project44/manifest-ds';

interface ILinkCard {
  children: JSX.Element | JSX.Element[];
  label: string;
  to: string;
  variant?: 'dark';
  onShow?: (key: string) => void;
}

function LinkCard({ children, label, to, variant }: ILinkCard) {
  const isDark = variant === 'dark';
  return (
    <Card
      css={{
        bgColor: isDark ? 'rgba(9, 21, 33, 20%)' : '$background-primary',
        flex: '1 1',
        minWidth: '340px',
        maxWidth: isDark ? '360px' : '520px',
      }}
    >
      {children}
      <Link to={to} style={{ textDecoration: 'none' }}>
        <Flex
          align="center"
          justify="end"
          gap="x-small"
          css={{
            borderTop: isDark ? '' : '1px solid $border-primary',
            bgColor: isDark ? 'rgba(9, 21, 33, 40%)' : '',
            color: isDark ? '$text-contrast' : '$primary-default',
            padding: '$medium',
            '&:hover': {
              bgColor: isDark ? 'rgba(9, 21, 33, 60%)' : '$palette-grey-100',
            },
          }}
        >
          <Typography variant="subtextBold">{label}</Typography>
          <Icon icon="arrow_forward" css={{ fontSize: '$large' }} />
        </Flex>
      </Link>
    </Card>
  );
}

export default LinkCard;
